import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'view-text-modal-app',
      templateUrl: './a-view-text-modal.component.html',
      styleUrls: ['mail.component.css']
    })

export class AViewTextModalComponent {
  @Input() view_title;
  @Input() view_text;

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ret:any={
    status:"",
  }

  modalCloseOK() {
    this.ret.status = 'OK';
    this.activeModal.close(this.ret);
  }
  modalCloseCancel(){
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}




// WEBPACK FOOTER //
// ./src/app/a0106-mail/a-view-text-modal.component.ts